import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  getAd,
  createUniqueAdId,
  includeAdMarkup
} from "@wattpad/client-platform-web-ads";

const AdContainer = ({ placement, adData, className, wrapperClassName }) => {
  const [uniquePlacement] = useState(createUniqueAdId(placement));
  const renderAd = includeAdMarkup(
    placement,
    adData.testGroups,
    adData.context
  );
  const initializeAd = () => {
    if (renderAd.result) {
      getAd({
        ...adData,
        placement: uniquePlacement
      });
    } else {
      if (
        typeof __atha !== "undefined" &&
        renderAd.reason.includes("skipped_special_placement_")
      ) {
        // this would ideally live in the ads package but due to some rendering issues includeAdMarkup gets called
        // multiple times.
        // eslint-disable-next-line no-undef
        __atha.sendSkip(
          placement,
          renderAd.reason,
          adData?.context?.story,
          adData?.context?.storyPart
        );
      }
    }
  };

  const adComponent = () => {
    return <div className={className} id={uniquePlacement} />;
  };

  const ConditionalAdWrapper = () => {
    return wrapperClassName ? (
      <div className={wrapperClassName}>{adComponent()}</div>
    ) : (
      adComponent()
    );
  };

  useEffect(initializeAd, [renderAd.result]);

  return renderAd.result ? ConditionalAdWrapper() : null;
};

AdContainer.propTypes = {
  placement: PropTypes.string.isRequired,
  adData: PropTypes.object,
  className: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string
};

export default AdContainer;
